<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
       
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">  Faculty Details </div>
      </ion-col>

      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <!--facultyname-form.component.html -->

    <form [formGroup]="addFacultyForm" style="margin: 10px;">
      <ion-row>
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Faculty Name</div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="facultyName" readonly   />
          </mat-form-field>
        </ion-col>
    
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Contact No.</div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput type="number" formControlName="contactNumber" />
          </mat-form-field>
        </ion-col>
    
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Email ID </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput type="email" formControlName="email"  />
          </mat-form-field>
        </ion-col>
    
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Details</div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="details"  />
          </mat-form-field>
        </ion-col>
    
        <ion-col size="4" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Link</div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="link" />
          </mat-form-field>
        </ion-col>
      </ion-row>
    
      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button class="back_btn fs-14" (click)="closeDialog()">Cancel</button>
       
        </ion-col>
      </ion-row>
    </form>
    
  </div>
</div>
